import { FunctionalComponent, h } from "@stencil/core";

interface ContentProps {
  name: string;
  label: string;
  hint?: string;
  error?: string;
  onInput: (event: InputEvent) => void;
  key: any;
}

export const ContentInput: FunctionalComponent<ContentProps> = (props) => {
  // const { name, label, hint, error, key, onInput } = props;

  return (
    <div class="hr-input-content" key={props.key}>

    </div>
  )
}
